var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-header',{attrs:{"title":_vm.title,"url":_vm.url,"titleNew":_vm.titleNew}}),_c('grid',{attrs:{"url":_vm.urlDataSource,"columns":_vm.columns,"GridHeight":400}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }